import styled from '@material-ui/styles/styled';
import { Card } from '@vkontakte/vkui';
import { CardProps } from '@vkontakte/vkui/dist/components/Card/Card';

export default styled(Card)({
  borderRadius: '8px!important',
}) as React.FC<CardProps>;
